import React, { useEffect } from "react";
import "./Evaluation.css";
import Header from "./Components/Header";
import Selectchild from "./Components/Selectchild";
import Progresslanguage from "./Components/Progresslanguage";
import Questionlist from "./Components/Questionlist";
import Buttonhandler from "./Components/Buttonhandler";
import { useNavigate, useParams } from "react-router-dom";
import usePost from "../../Hooks/usePost";
import { Domain, Workspace } from "../../path";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Set_Loader } from "../../Redux/Action/LoaderAction";
import useGet from "../../Hooks/useGet";
import { toast } from "react-toastify";

const Evaluation = () => {
  const { school_id, id, type, child_id, qtype } = useParams();
  const Dispatch = useDispatch();
  const Navigate = useNavigate();
  const [PendingListData, setPendingList] = useState(null);
  const [QuestionList, setQuestionList] = useState([]);
  const [Language_option, setLanguage_option] = useState(1);
  const [Remark, setRemark] = useState("");
  const Pendinglist = usePost(
    `${Workspace[Domain].API_Path}/pending_child_list`
  );
  const Childdetails = usePost(`${Workspace[Domain].API_Path}/child_details`);
  const Language_list = useGet(`${Workspace[Domain].API_Path}/language_list`);
  const Acadamic_Get = usePost(
    `${Workspace[Domain].API_Path}/${
      qtype == 1
        ? "academic_questions"
        : qtype == 2
        ? "behaviour_questions"
        : ""
    }`
  );
  const Answer_Post = usePost(
    `${Workspace[Domain].API_Path}/${
      qtype == 1
        ? "save_academic_questions"
        : qtype == 2
        ? "save_behaviour_questions"
        : ""
    }`
  );
  const Answer_Post_Validate = usePost(
    `${Workspace[Domain].API_Path}/${
      qtype == 1
        ? "save_academic_questions"
        : qtype == 2
        ? "save_behaviour_questions"
        : ""
    }`
  );

  const SubmitANswer = (validate) => {
    if (validate) {
      let proceed = true;
      QuestionList?.forEach((item, index) => {
        if (String(item?.given_answer) == "" || item?.given_answer == null) {
          proceed = false;
        }
      });
      if (qtype == 2 && Remark == "") {
        proceed = false;
      }
      if (proceed) {
        PostAnswer_Api_validate();
      } else {
        toast.warn("Kindly answer all question");
        toast.clearWaitingQueue();
      }
    } else {
      PostAnswer_Api_non_validate();
    }
  };

  const PostAnswer_Api_validate = () => {
    Answer_Post_Validate.Postcall({
      child_id: atob(child_id),
      analysis: QuestionList,
      remarks: Remark,
    });
  };
  const PostAnswer_Api_non_validate = () => {
    Answer_Post.Postcall({
      child_id: atob(child_id),
      analysis: QuestionList,
      remarks: Remark,
    });
  };

  useEffect(() => {
    Language_list.refetch("");
    if (type == "other") {
      Pendinglist.Postcall({
        school_id: atob(id),
      });
    } else if (type == "class") {
      Pendinglist.Postcall({
        class_id: atob(id),
      });
    } else if (type == "individual") {
      Childdetails.Postcall({
        child_id: atob(child_id),
      });
    }
    return () => {
      setPendingList(null);
      setQuestionList([]);
      // setLanguage_option(1);
      setRemark("");
    };
  }, [id, type, child_id, qtype]);

  // LANGUAGE LIST
  useEffect(() => {
    if (Language_list?.data != null) {
      switch (Language_list?.data?.status) {
        case 200:
          break;

        default:
          break;
      }
    }
  }, [Language_list?.data]);

  // LANGUAGE CHANGE
  useEffect(() => {
    if (Language_option != null && qtype != "load") {
      Acadamic_Get.Postcall({
        child_id: atob(child_id),
        language_id: Language_option,
      });
    }
  }, [Language_option]);

  // PENDING LIST
  useEffect(() => {
    if (Pendinglist?.Post != null) {
      switch (Pendinglist?.Post?.status) {
        case 200:
          setPendingList(Pendinglist?.Post?.body);
          if (Pendinglist?.Post?.body?.length) {
            Navigate(
              `/evaluation/${school_id}/${id}/${type}/${
                child_id == "load"
                  ? btoa(Pendinglist?.Post?.body[0]?.child_view_id)
                  : child_id
              }/${qtype == "load" ? 1 : qtype}`
            );
            if (qtype != "load") {
              Acadamic_Get.Postcall({
                child_id:
                  child_id == "load"
                    ? btoa(Pendinglist?.Post?.body[0]?.child_view_id)
                    : atob(child_id),
                language_id: Language_option,
              });
            }
          } else {
            Navigate(`/analysis/${id}/${type}`);
            Dispatch(Set_Loader(false));
          }
          break;

        default:
          break;
      }
    }
  }, [Pendinglist.Post]);

  useEffect(() => {
    if (Acadamic_Get.Post != null) {
      switch (Acadamic_Get.Post?.status) {
        case 200:
          Dispatch(Set_Loader(false));
          setQuestionList(() => Acadamic_Get.Post.body);
          break;

        default:
          break;
      }
    }
  }, [Acadamic_Get.Post]);

  // ANSWER POST
  useEffect(() => {
    if (Answer_Post?.Post != null) {
      switch (Answer_Post?.Post?.status) {
        case 200:
          // Dispatch(Set_Loader(false));
          Acadamic_Get.Postcall({
            child_id:
              child_id == "load"
                ? btoa(Pendinglist?.Post?.body[0]?.child_view_id)
                : atob(child_id),
            language_id: Language_option,
          });
          toast.success("Saved successfully");
          toast.clearWaitingQueue();
          break;

        default:
          break;
      }
    }
  }, [Answer_Post.Post]);
  // ANSWER POST VALIDATE
  useEffect(() => {
    if (Answer_Post_Validate?.Post != null) {
      switch (Answer_Post_Validate?.Post?.status) {
        case 200:
          Dispatch(Set_Loader(false));
          if (qtype == 1) {
            Navigate(`/evaluation/${school_id}/${id}/${type}/${child_id}/2`);
          } else if (qtype == 2) {
            if (type == "individual") {
              Navigate(`/classdetail/${school_id}/${id}`);
            } else {
              Navigate(`/evaluation/${school_id}/${id}/${type}/load/load`);
            }
          }
          toast.success("Saved successfully");
          toast.clearWaitingQueue();
          break;

        default:
          break;
      }
    }
  }, [Answer_Post_Validate.Post]);
  useEffect(() => {
    if (Childdetails?.Post != null) {
      switch (Childdetails?.Post?.status) {
        case 200:
          // Dispatch(Set_Loader(false));
          setPendingList([Childdetails?.Post?.body]);
          if (qtype != "load") {
            Acadamic_Get.Postcall({
              child_id:
                child_id == "load"
                  ? btoa(Pendinglist?.Post?.body[0]?.child_view_id)
                  : atob(child_id),
              language_id: Language_option,
            });
          }
          break;

        default:
          break;
      }
    }
  }, [Childdetails?.Post]);

  return (
    <div className="w-full h-full bg-[white]">
      {/*SECTION Below 740px header */}
      <Header
        Childlist={PendingListData}
        Language_list={Language_list?.data?.body}
        Language_option={Language_option}
        setLanguage_option={setLanguage_option}
      />
      {/*SECTION QUESTION SLOT START */}
      <div className="w-10/12 mx-auto h-full flex items-start justify-center max-[740px]:w-full">
        {/*LINK  CHILD SELECT START */}
        <Selectchild Childlist={PendingListData} />
        {/*LINK RIGHT START */}
        <div className="w-9/12 mx-auto h-full max-[740px]:w-full">
          {/*LINK PROGRESS AND LANGUAGE START */}
          <Progresslanguage
            Language_list={Language_list?.data?.body}
            Language_option={Language_option}
            setLanguage_option={setLanguage_option}
          />
          {/*LINK QUESTION LIST START */}
          <Questionlist
            QuestionList={QuestionList}
            setQuestionList={setQuestionList}
            Remark={Remark}
            setRemark={setRemark}
          />
          {/*LINK SUBMIT BUTTON START  */}
          <Buttonhandler SubmitANswer={SubmitANswer} />
        </div>
      </div>
    </div>
  );
};

export default Evaluation;
